/** @format */

import EN from '../../i18n/translations/cities/en.json';
import FR from '../../i18n/translations/cities/fr.json';
import IT from '../../i18n/translations/cities/it.json';
import ES from '../../i18n/translations/cities/es.json';
import { TLocale, TLocalesObject } from '../../utils/gatsby/types';

const allCities: TLocalesObject<typeof EN> = {
  en: EN,
  fr: FR,
  it: IT,
  es: ES,
};

export const getCityFormattedName = (cityName: string, locale: TLocale) => {
  const translations = allCities[locale];

  if (!Object.keys(translations).includes(cityName)) {
    throw new Error(`[getCityFormattedName] City name not found in translations: ${cityName}`);
  }
  return translations[cityName as keyof typeof translations];
};
